import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  publicLinkId: string;
}


interface ResponseDataType {
  viewed_at: string | null;
}

export const viewPublicLinkCustomFormReportFormRequest = ({ publicLinkId, }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-report/public-link/${ publicLinkId }/view-form`, {
    method: 'PUT',
  });
};